import { FC } from 'react'
import { twMerge } from '@lib/tailwind-merge'

interface Props {
  className?: string
  content: string
  count: number
  hideCount?: boolean
}

export const Label: FC<Props> = ({
  className,
  content,
  count,
  hideCount = false,
}) => (
  <span
    className={twMerge(
      'text-sm font-semibold uppercase text-neutral-900',
      className,
    )}
  >
    {content} {!hideCount && `(${count})`}
  </span>
)
